import { createStore } from '@stencil/store';
import { StorageAdapter } from './adapters/adapter-interface';
import { Build } from '@stencil/core';

export class MapStore<T> {
    private readonly state: { items: { [key: string]: T } };
    private readonly store;

    constructor(private adapter: StorageAdapter<T>) {
        if (Build?.isServer) return;

        this.store = createStore<{ items: { [key: string]: T } }>({ items: {} });
        const { state, use } = this.store;
        this.state = state;

        //Populate store with get all from adapter
        state.items = adapter.getAll();

        //Hook store changes to adapter
        use({
            set: (_, newValue, oldValue) => {
                const newKeys = Object.keys(newValue);
                const oldKeys = Object.keys(oldValue);

                if (oldKeys.length > newKeys.length) {
                    const key = oldKeys.find((k) => !newKeys.includes(k));
                    this.adapter.delete(key);
                } else if (oldKeys.length < newKeys.length) {
                    const key = newKeys.find((k) => !oldKeys.includes(k));
                    this.adapter.set(key, newValue[key]);
                } else {
                    const key = newKeys.find((k) => oldValue[k] != newValue[k]);
                    this.adapter.set(key, newValue[key]);
                }
            },
            reset: () => {
                this.adapter.clear();
            }
        });
    }
    public get = (key: string) => {
        //TODO: If not found, check if adapter has it and update store if needed?
        return this.state.items[key];
    };
    public getAll = () => {
        //TODO: check if in sync with adapter getAll values?
        return { ...this.state.items };
    };
    public set = (name: string, value: T) => {
        this.state.items = {
            ...this.state.items,
            [name]: value
        };
    };
    public has = (key: string) => {
        return key in this.state.items;
    };
    public clear = () => {
        this.store.reset();
    };
    public delete = (key: string) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [key]: _, ...rest } = this.state.items;
        this.state.items = rest;
    };
}
